import i18n from "../i18n";
import { getAppConfig } from "../constants/appConfig";

const getUrlLanguage = () => {
  switch (i18n.language) {
    case "da":
      return "da";

    case "de":
      return "de";

    case "en":
      return "en";

    case "es":
      return "es";

    case "fr":
      return "fr";

    case "hu":
      return "hu";

    case "it":
      return "it";

    case "ja":
      return "ja";

    case "ko":
      return "ko";

    case "nl":
      return "nl";

    case "pl":
      return "pl";

    case "pt":
      return "pt";

    case "sv":
      return "sv";

    case "zh-CN":
    case "zh-Hans":
      return "zh-hans";

    case "zh-HK":
    case "zh-TW":
    case "zh-Hant":
      return "zh-hant";

    default:
      return "en";
  }

};

const replaceLanguage = (url) =>
  url?.replace("{{language}}", getUrlLanguage());

const getLegalLinks = () => {
  const config = getAppConfig();
  return {
    termsOfUse: replaceLanguage(config.REACT_APP_TERMS_URL),
    privacyStatement: replaceLanguage(config.REACT_APP_PRIVACY_URL),
    cookieInformation: replaceLanguage(config.REACT_APP_COOKIE_URL),
  };
};

export default getLegalLinks;